import { Component, input } from '@angular/core';
import { GcIconComponent, GcTextComponent } from '@ip-only/front-end-library';
import { StatusStyleMap } from '../status-style/status-style.entities';
import { StatusStylePipe } from '../status-style/status-style.pipe';

@Component({
  selector: 'app-status-table-cell',
  imports: [StatusStylePipe, GcTextComponent, GcIconComponent],
  templateUrl: './status-table-cell.component.html',
  styleUrl: './status-table-cell.component.scss',
})
export class StatusTableCellComponent<S extends string> {
  status = input<S>();
  styleMap = input.required<StatusStyleMap<S>>();
  firstLine = input<string>('-');
  secondLine = input<string>();
}
